import { GlobalService } from 'src/app/_services/global.service';
import { UserService } from 'src/app/_services/user.service';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { User } from '../_models/user/user';
import { take } from 'rxjs/operators';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  _globals = GlobalService
  constructor(private _userService: UserService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const url = request.url.toLocaleLowerCase()
    if(request.url.includes('authorize.net')) {
      return next.handle(request)
    }

    // Prefer the business's actual active timezone (GeneralComponent keeps this IANA-converted value
    // fresh from business/timezoneoptions / business/timezone) over the browser/device's local zone,
    // so a staff member logging in from a different location than the business still reports the
    // business's zone. businessSetup[0].standardsForms.timeZone is a separate legacy field that the
    // current save flow doesn't update, so it can go stale and isn't used here. Falls back to the
    // device zone until GeneralComponent has loaded at least once this session (e.g. right after
    // login, or during signup before a business exists).
    const deviceTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    const timeZone = GlobalService.activeBusinessTimeZoneIana || deviceTimeZone;

    let currentUser: User;
    this._userService.currentUser$.pipe(take(1)).subscribe((user: User) => currentUser = user);
    if (currentUser) {
      request = request.clone({
        setHeaders: {
          WLID: (this._globals.whiteLabel) ? this._globals.whiteLabel.id:'',
          Authorization: `Bearer ${currentUser.token}`,
          'X-Time-Zone': timeZone
        }
      })
    } else {
      request = request.clone({
        setHeaders: {
          WLID: (this._globals.whiteLabel) ? this._globals.whiteLabel.id:'',
          'X-Time-Zone': timeZone
        }
      })
    }

    return next.handle(request);
  }
}
